import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { INTERBRANCH_MODAL_UPDATE } from '../../actions/type';
import './UnsavedChangesConfirmation.css';

function UnsavedChangesConfirmation() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state?.interBranchCoordinator?.modals?.unsavedChangesConfirmation);

  const handleConfirm = () => {
    if (data?.onConfirm) {
      data.onConfirm();
    }
    closeModal();
  };

  const handleCancel = () => {
    if (data?.onCancel) {
      data.onCancel();
    }
    closeModal();
  };

  const closeModal = () => {
    dispatch({
      type: INTERBRANCH_MODAL_UPDATE,
      payload: {
        modalName: "unsavedChangesConfirmation",
        isVisible: false,
        data: null
      }
    });
  };

  if (!data) return null;

  return (
    <div className="unsaved-changes-confirmation-overlay">
      <div className="unsaved-changes-confirmation-modal">
        <div className="unsaved-changes-confirmation-body">
          <h3 className="warning-message">
            Do you really want to discard the current progress ?
          </h3>
        </div>
        
        <div className="unsaved-changes-confirmation-footer">
          <button 
            className="cancel-btn" 
            onClick={handleCancel}
          >
            No
          </button>
          <button  
            className="confirm-btn" 
            onClick={handleConfirm}
          >
            Yes
          </button>
        </div>
      </div>
    </div>

    
  );
}

export default UnsavedChangesConfirmation;
